/* eslint-disable import/prefer-default-export */

export const registerServiceWorker = () => false;
